<template>
	<div class="dggk-con">
		<!-- <divBox1 :title="'电港概况'"></divBox1> -->
    	<title1 title="电港概况" subTitle="Electric Port Overview" />
		<div class="main-box-diangganggaikuang">
			<div
				v-for="(item, i) in target"
				:key="'target' + i"
				class="main-box-cell align-center">
				<img class="img" :src="item.icon" alt="" />
				<div class="main-box-right flex1">
					<div class="top">{{ item.label }}</div>
					<div class="bottom flex align-center">
						<div class="number DS-Digital-Bold">{{ item.number }}</div>
						<div class="unit">{{ item.unit }}</div>
					</div>
				</div>
			</div>
			<!-- <div class="main-box-cell">
				<div class="main-box-left">
					<img src="" alt="">
				</div>
				<div class="main-box-right">
					<div class="top"></div>
					<div class="bottom">{{ Overview. }}</div>
				</div>
			</div>
			<div class="main-box-cell">
				<div class="main-box-left">
					<img src="" alt="">
				</div>
				<div class="main-box-right">
					<div class="top"></div>
					<div class="bottom">{{ Overview. }}</div>
				</div>
			</div>
			<div class="main-box-cell">
				<div class="main-box-left">
					<img src="" alt="">
				</div>
				<div class="main-box-right">
					<div class="top"></div>
					<div class="bottom">{{ Overview. }}</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import divBox1 from '@/views/mobile/components/divBox1'
  import title1 from '@/views/exposition/components/title1'
	import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	export default{
		components: {
			divBox1,
      title1
		},
    data() {
      return {
        // Overview: {}
		target: [
			{
				icon: require('@/assets/images/exposition/home-icon-1.png'),
				label: '光伏',
				number: '',
				unit: 'kW'
			},
			{
				icon: require('@/assets/images/exposition/home-icon-2.png'),
				label: '储能',
				number: '',
				unit: 'MWh'
			},
			{
				icon: require('@/assets/images/exposition/home-icon-3.png'),
				label: '充电桩',
				number: '',
				unit: '个'
			},
			{
				icon: require('@/assets/images/exposition/home-icon-4.png'),
				label: '换电站',
				number: '',
				unit: '座'
			}
		]
      }
    },
		methods: {
			//电港概况
			getDianganggaikaung() {
				let params = {
					"enCode": "snec-left-dianganggaikuang",
					"@harbour_id": localStorage.getItem("harbour_id") || '76df7579ccc24d2693f6488c38a3a0b0'
				}
				dataInterface.dataFaceApi(params).then((res) => {
					console.log(res, '电港概括')
					console.log(params, 'params')
					let data = res[0] || {}
					this.target[0].number = parseFloat(data.gf_rated_capacity || 0).toFixed(0)
					this.target[1].number = parseFloat(data.store_rated_capacity || 0).toFixed(0)
					this.target[2].number = parseFloat(data.chargingpile_num || 0).toFixed(0)
					this.target[3].number = parseFloat(data.chargingstation_num || 0).toFixed(0)
          			// this.Overview = res[0] || {}
				}).catch((err) => {
					console.log(err);
				});
			}
		},
    destroyed() {
				// this.$bus.$off('onfangdiangonglv')
			},
		mounted() {
      this.$bus.$on('onfangdiangonglv', ()=>{
					this.getDianganggaikaung()
				})
			this.getDianganggaikaung()
		}
	}
</script>

<style lang="scss" scope>
.dggk-con {
	.main-box-diangganggaikuang{
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		// margin-top: 40px;
		@keyframes breath_light {
		    0% {
		        filter: brightness(100%);
		    }
		    50% {
		        filter: brightness(180%);
		    }
		    100% {
		        filter: brightness(100%);
		    }
		}
		.main-box-cell{
			margin-bottom: 6px;
			display: flex;
			width: 50%;
			height: 90px;
			padding: 0;
			margin: 0;
			margin-top: 30px;
			// .main-box-left{
				.img {
					animation: breath_light 3s ease infinite;
					width: 80px;
					height: 50px;
				}
			// }
			.main-box-right{
				padding-left: 15px;
				.top{
					height: 50px;
					line-height: 70px;
					font-size: 18px;
				}
				.bottom{
					height: 50px;
					font-size: 22px;
					line-height: 30px;
					.number {
						color: #02b9bd;
						margin-right: 10px;
						font-size: 24px;
					}
					.unit {
						width: 40px;
						flex-shrink: 0;
						font-size: 16px;
					}
				}
			}
		}
	}
}
</style>